<style lang="scss" scoped>
.header {
    border-bottom: 1px solid #eee;
    overflow: auto;

    &__main {
        @include flex-center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    &__back {
        color: white;
        font-size: 16px;
        cursor: pointer;
        margin-right: 30px;
        svg {
            vertical-align: middle;
            margin-right: 5px;
        }
    }
    &__user {
        color: white;
        outline: 0;
        cursor: pointer;
        font-size: 16px;
    }
    &__logos {
        margin-right: 50px;
        cursor: pointer;
        @include flex-center;
        &__logo {
            height: 60px;
        }
        &.--wonde {
            margin-right: 00px;
        }
        &__text {
            color: #fff;
            background-color: transparent;
            font-size: 18px;
            font-weight: 500;
            margin-left: 20px;
        }
    }
    &__navigation {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
            display: inline-block;
        }
        a:hover {
            color: white;
        }
    }
    &__badge {
        vertical-align: middle !important;
        margin-left: 5px;
        margin-right: -5px;
        position: relative;
        top: -1px;
        font-weight: 600;
        font-size: 13px;
    }
    &__button {
        cursor: pointer;
        padding: 11px 15px;
        margin-right: 0px;
        color: white;
        font-size: 18px;
        border-radius: 4px;
        opacity: 0.5;
        &:hover {
            text-decoration: none;
            opacity: 1;
        }
        &.router-link-exact-active {
            opacity: 1;
        }
        &.router-link-active:not(.ignore-active-parent) {
            opacity: 1;
        }
    }
    &__page {
        background: white;
        border-top-left-radius: $radius;
        border-top-right-radius: $radius;
        padding: 30px 40px;
    }
    &__sticky {
        position: sticky;
        top: 0;
        z-index: 3;
    }
    h1 {
        padding: 0;
        line-height: unset;
        margin: 0;
    }
}
</style>
<template lang="pug">
div
  .header
    .container
      .header__main
        .header__logos(@click='goHome()')
          img.header__logos__logo.--google(src='/google-logo.svg', alt='', v-show='providerCode === "gapps"')
          img.header__logos__logo.--google(src='/google-logo.svg', alt='', v-show='providerCode === "gappsm"')
          img.header__logos__logo.--msft(src='/msft-logo.svg', alt='', v-show='providerCode === "msft"')
          img.header__logos__logo.--msft(src='/msft-logo.svg', alt='', v-show='providerCode === "msad"')
          img.header__logos__logo.--apple(src='/apple-logo.svg', alt='', v-show='providerCode === "apl"')
          .header__logos__text Edusync {{ providerName }}
        ul.header__navigation(v-if='settings && (providerCode === "apl" || settings.has_completed_wizard === true)')
          li
            router-link.header__button.ignore-active-parent(to='/') Directory
          li
            a.header__button(href="/settings", e2e="settings_button") Settings
          li(v-if="providerCode == 'apl'")
            router-link.header__button(tag='a', :to='{name : "classes"}') {{ 'Classes'}}
          li(v-if="providerCode == 'gapps' || providerCode === 'msft'")
            el-dropdown(@command='routing' trigger="click")
              span.el-dropdown-link.header__button Tools
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown', v-if="providerCode === 'msft'")
                el-dropdown-item(command='matching') Matching
                el-dropdown-item(command='activity') Activity
                el-dropdown-item(command='teams') Teams
              el-dropdown-menu(slot='dropdown', v-else)
                el-dropdown-item(command='matching') Matching
                el-dropdown-item(command='activity') Activity
                el-dropdown-item(command='classrooms') Classrooms
                el-dropdown-item(command='communication') Send credentials
                el-dropdown-item(command='guardian') Invite parents/caregivers
          li
            a.header__button( target='_blank', :href="helpLinks[providerCode] || helpLinks.gapps") Help
        .header__back.ml-auto(@click='backToWonde', e2e="header-back-to-wonde-global")
          i.feather.icon-arrow-left.mr-2
          | Back to Wonde
        .header__user(v-if='user')
          el-dropdown(@command='command', e2e="header-user-commands" trigger="click")
            span.el-dropdown-link.header__user
              | {{user.first_name}} {{user.last_name}}
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item(v-if="user.organisation_id" command='schools', e2e="header-schools") Switch School
              el-dropdown-item(command='wonde', e2e="header-back-to-wonde") Back to Wonde
              el-dropdown-item(command='logout', e2e="header-logout") Logout
    .container.header__sticky
      .header__page
        slot(name='header')
</template>
<script>
import gql from "graphql-tag";
import { onLogout } from "./../vue-apollo";
export default {
    data() {
        return {
            user: null,
            settings: null,
            helpLinks: {
                apl: "http://help.wonde.com/en/collections/3536658-edusync-apple",
                msft: "http://help.wonde.com/en/collections/3882083-edusync-microsoft", 
                gapps: "http://help.wonde.com/en/collections/1608415-edusync-google"
            },
            school: {}
        };
    },
    
    methods: {
        backToWonde() {
            window.location = this.user.organisation_id ? process.env.VUE_APP_ENTERPRISE_PORTAL_URL : process.env.VUE_APP_WONDE_URL;
        },
        redirectToSchools() {
            this.$router.push({name : "organisation.schools"});
        },
        command(command) {
            switch (command) {
                case "logout":
                    onLogout(this.$apollo.vm.$apolloProvider.clients.defaultClient);
                    this.backToWonde();
                    break;
                case "wonde":
                    this.backToWonde();
                    break;
                case "schools":
                    this.redirectToSchools();
                    break;
                default:
                    break;
            }
        },
        routing(route){
            switch(route){
                case "classrooms":
                    this.$router.push({name : "classrooms"});
                    break;
                case "activity":
                    this.$router.push({name : "activity"});
                    break;
                case "communication":
                    this.$router.push({name : "communication"});
                    break;
                case "guardian":
                    this.$router.push({name : "guardian"});
                    break;
                case "matching":
                    this.$router.push({name : "matching"});
                    break;
                case "teams":
                    this.$router.push({name : "teams"});
                    break;
                default:
                    break;
            }
        },
        async redirectToWizard() {
            await this.$apollo.queries.settings.refetch();

            if (!this.settings.has_completed_wizard) {
                this.$router.replace({ name: "wizard" });
            }
        },
        goHome() {
            if (this.user.organisation_id) {
                this.$router.push({name:"organisation.schools"});
            } else {
                this.$router.push({name:"directory"});
            }
        }
    },

    apollo: {
        user: {
            query: gql`
                {
                    User {
                        first_name
                        last_name
                        organisation_id
                    }
                }
            `,
            update: (r) => r.User,
        },
        settings: {
            query: gql`
                {
                    Settings {
                        id
                        has_completed_wizard
                        connected
                    }
                }
            `,
            update: (r) => r.Settings,
        },
        school: {
            query: gql`
                {
                    School {
                        Organisation {
                            id
                            name
                            active
                        }
                    }
                }
            `,
            update: (r) => r.School,
        },
        hasSchoolConnection: {
			query: gql`
				{
					HasSchoolConnection
				}
			`,
			update: r => r.HasSchoolConnection
		}
    },
    watch: {
        "settings.has_completed_wizard"() {
            // The user should be doing the wizard if they have not completed it yet
            if (this.$route.meta.completedWizard === true && this.settings.has_completed_wizard === false) {
                this.redirectToWizard();
            }
        },

        "settings.connected"() {
            // OAuth reconnected required
            if (this.settings.connected === false && this.settings.has_completed_wizard === true) {
                this.$router.replace({ name: "connect.reconnect" });
            }
        },

        "hasSchoolConnection"() {
            if (!this.hasSchoolConnection) {
                this.$router.replace({ name: "errors.connection" });
            }
        },

        "school.Organisation.active"() {
            if (this.providerCode === "apl" && this.school.Organisation && !this.school.Organisation.active && this.user.organisation_id) {
                this.$router.replace({ name: "errors.organisationNotActive" }); 
            }
        }
    },
};
</script>
